/* LoginFormComponent.js */

"use strict";
const _ = require('lodash');
const EventEmitter = require('events').EventEmitter;
const Renderer = require("./LoginFormRenderer");

class LoginFormComponent extends EventEmitter {

    constructor() {
        super();
        this._isChallengeForm = false;
        this._renderer = new Renderer(this);
    }
    /*******************************************/
    /* START PRIVATE COMPONENT MODEL METHODS */
    /*******************************************/
    // _registerListeners(){
    //
    // }
    // _unregisterListeners(){}

    /*******************************************/
    /* END PRIVATE COMPONENT MODEL METHODS */
    /* START PUBLIC COMPONENT MODEL METHODS */
    /*******************************************/
    get renderer(){
        return this.getRenderer();
    }
    getRenderer(){
        return this._renderer;
    }
    shutdown(){
        return this._renderer.shutdown()
            .then(() => {
                this._isChallengeForm = undefined;
                this._renderer = undefined;
            }, (err) => {
                console.log("Error shutting down LoginFormComponent: ", err);
            });
    }

    loginRequest(username, password){
        this.emit("login.request",{
            username: username,
            password: password
        });
    }

    usernameRequest(email){
        this.emit("username.request", email);
    }

    passwordRequest(email){
        this.emit("password.request", email);
    }

    /*******************************************/
    /* END COMPONENT MODEL METHODS */
    /* START PRIVATE METHODS */
    /*******************************************/

    /*******************************************/
    /* END PRIVATE METHODS */
    /* START PUBLIC API METHODS */
    /*******************************************/

    hideHelp(){
        this.emit("help.hide");
    }

    set errorMsg(msg) { // jshint ignore:line
        this.emit("msg-error",msg);
    }

    set infoMsg(msg) { // jshint ignore:line
        if(_.isString(msg)){
            this.emit("msg-info",msg);
        }
    }
    clearPassword() {
        this.emit("clear-password");
    }

    _changeFormToChallenge() {
        this._isChallengeForm = true;
        this.emit("ChangeFormToChallenge");
    }

    /*******************************************/
    /* END PUBLIC API METHODS */
    /*******************************************/
}
module.exports=LoginFormComponent;
